function require(templateName){
	var x = window[templateName]
	return x;
}
